import { createStore, produce } from "solid-js/store";

const BREAKPOINT = 1172;
const THROTTLE_DELAY = 200; // 200ms 的节流时间

const [state, setState] = createStore({
  isExpanded: true,
});

// 节流函数
const throttle = <T extends (...args: unknown[]) => void>(
  fn: T,
  delay: number,
) => {
  let lastCall = 0;
  return function (...args: Parameters<T>) {
    const now = Date.now();
    if (now - lastCall >= delay) {
      lastCall = now;
      return fn(...args);
    }
  };
};

// 切换侧边栏展开/收起状态
export const toggleSidebar = () => {
  setState(
    produce((s) => {
      s.isExpanded = !s.isExpanded;
    }),
  );
};

// 监听窗口大小变化
const handleResize = throttle(() => {
  const shouldBeExpanded = window.innerWidth > BREAKPOINT;
  setState(
    produce((s) => {
      s.isExpanded = shouldBeExpanded;
    }),
  );
}, THROTTLE_DELAY);

// 初始化
const initSidebar = () => {
  // 设置初始状态
  setState(
    produce((s) => {
      s.isExpanded = window.innerWidth > BREAKPOINT;
    }),
  );

  // 添加 resize 事件监听
  window.addEventListener("resize", handleResize);

  // 返回清理函数
  return () => {
    window.removeEventListener("resize", handleResize);
  };
};

// 导出
export const sidebarStore = {
  state,
  toggleSidebar,
  initSidebar,
};
